import { Step } from "react-joyride";

export const clarificationsRegisterSteps: Step[] = [
	{
		target: '[data-testid="add-clarification-button"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Create Clarifications</h3>
				<p>
					Add clarification questions for suppliers. Each clarification targets a
					specific supplier and can be assigned a type and category.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
	{
		target: '[title="Edit"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Edit Draft Clarification</h3>
				<p>
					Click to open and edit a draft clarification before sending. You can
					update the question text, type, category, and attached files. You can also click anywhere on the row to edit a draft too.
				</p>
			</div>
		),
		placement: "left",
		disableBeacon: true,
	},
	{
		target: '[data-guide-action="copy-draft"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Copy Clarification to Other Suppliers</h3>
				<p>
					Duplicate a clarification to other suppliers. Choose which suppliers
					should receive the same question — saves time when the same
					clarification applies to multiple respondents.
				</p>
			</div>
		),
		placement: "left",
		disableBeacon: true,
	},
	{
		target: '[title="Delete"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Delete Draft Clarification</h3>
				<p>
					Remove a draft clarification that is no longer needed. Only unsent
					drafts can be deleted.
				</p>
			</div>
		),
		placement: "left",
		disableBeacon: true,
	},
	{
		target: '.clarification-row-checkbox',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Select Clarifications</h3>
				<p>
					Use the checkboxes to select one or more draft clarifications.
					Selected clarifications can then be sent to suppliers in bulk.
				</p>
			</div>
		),
		placement: "right",
		disableBeacon: true,
	},
	{
		target: '[data-testid="send-clarifications-button"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Send to Suppliers</h3>
				<p>
					Once you&apos;ve selected draft clarifications, click here to send them.
					Suppliers will be notified via email and can respond directly.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
	{
		target: '[title="View"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">View Clarification</h3>
				<p>
					Click to open the full clarification detail view. You can review the
					question, supplier response, and any attached files. You can also access this by just clicking on the row.
				</p>
			</div>
		),
		placement: "left",
		disableBeacon: true,
	},
	{
		target: '[title="Chat about this clarification"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Message Supplier</h3>
				<p>
					Open a conversation thread with the supplier about this specific
					clarification. Messages are tracked and timestamped for auditing purposes.
				</p>
			</div>
		),
		placement: "left",
		disableBeacon: true,
	},
	{
		target: '[title="Mark as Complete"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Mark as Complete</h3>
				<p>
					Once a supplier has adequately responded, mark the clarification as
					complete. You can reopen it later if further follow-up is needed.
				</p>
			</div>
		),
		placement: "left",
		disableBeacon: true,
	},
	{
		target: '[title="Reopen Clarification"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Reopen Clarification</h3>
				<p>
					If further follow-up is needed after marking a clarification as
					complete, click here to reopen it. If the Supplier has already responded, they cannot respond again.
				</p>
			</div>
		),
		placement: "left",
		disableBeacon: true,
	},
	{
		target: '[data-testid="step-next-button"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Proceed to Next Step</h3>
				<p>
					Once all draft clarifications have been sent, click Next to proceed
					to the Revisions step. You can continue to manage responses while
					revisions are in progress.
				</p>
			</div>
		),
		placement: "top",
		disableBeacon: true,
	},
];
